import { useState, useEffect } from 'react';
import axios, { endpoints } from 'src/utils/axios';
import { BankOptionType } from 'src/type/bank';
import { useBoolean } from './use-boolean';

export type BankOptions = {
  name: string;
  value: string;
  shortName: string;
  imageUrl: string;
};

export default function useBankOptions() {
  const loading = useBoolean(true);
  const [options, setOptions] = useState<BankOptions[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get<BankOptionType[]>(endpoints.backAccount.bank);
        const opt = data?.map((bank) => ({
          name: bank.name,
          value: bank.id,
          shortName: bank.shortName,
          imageUrl: bank.imageUrl,
        }));

        setOptions(opt);
      } catch (error) {
        setOptions([]);
      } finally {
        loading.onFalse();
      }
    })();
  }, []);

  return { bankOptions: options, isBankOptionsLoading: loading.value };
}
